<template>
    <transition name="fade" appear>
        <!-- Фон-затемнение -->
        <div
            v-if="isOpen"
            class="gz-modal__bcg"
            @click.self="modalClose"
            ref="modal"
        >
            <span @click="modalClose" class="icon-cross gz-modal__close-icon"></span>
            <!-- Контейнер модального окна -->
                <div v-if="isOpen" class="gz-modal__container">
                    <div class="gz-modal__body">
                        <component 
                            :is="component ? component.component : false" 
                            :data="component ? component.data : false" 
                        />
                    </div>
                </div>
            <!-- End Контейнер модального окна -->
        </div>
        <!-- End Фон-затемнение -->
    </transition>
</template>

<script>
export default {
    computed: {
        isOpen() {
            return this.$store.getters['modalOpen']
        },
        component() {
           return this.$store.getters['modalComponent']
        }
    },
    methods: {
        modalClose() {
            this.$store.dispatch('modalClose')
        }
    }
}
</script>